import {MESSAGE_INTEGRATIONS} from '../../../utils/messageIntegrations.config';
import styles from './styles.module.css';

export default function MessageIntegrations({activeIntegrations, onSideEffect}) {
  if (!activeIntegrations?.length) {
    return null;
  }

  return (
    <div className={styles.messageIntegrations}>
      {activeIntegrations.map(({key, props}) => {
        const entry = MESSAGE_INTEGRATIONS[key];
        if (!entry?.component) {
          return null;
        }
        const Component = entry.component;
        return (
          <Component
            key={key}
            {...entry.defaultProps}
            {...props}
            onSideEffect={onSideEffect}
          />
        );
      })}
    </div>
  );
}
